<template>
  <FormWrapper type="forgot">
    <template slot="head" v-if="!isCompleted">
      <h3 class="kt-login__title">Change your Password</h3>
      <div class="kt-login__desc">Please enter your new password twice so we can verify you typed it in correctly.</div>
    </template>

    <template slot="head" v-if="isCompleted">
      <h3 class="kt-login__title">{{ message.text }}</h3>
      <div class="kt-login__desc">Now login with your new password.</div>
      <button type="submit" class="btn btn-primary btn-wide mt-4" @click="redirect('login')">Login</button>
    </template>

    <div
      class="alert fade show"
      :class="messageObj"
      v-if="message.text && !isCompleted">
      <div class="alert-icon text-white">
        <BaseIcon type="fas" icon="times" size="2x" v-if="this.message.class === 'error'" />
        <BaseIcon type="fas" icon="exclamation-triangle" size="2x"  v-if="this.message.class === 'warning'" />
        <BaseIcon type="fas" icon="check" size="2x"  v-if="this.message.class === 'success'" />
      </div>
      <div class="alert-text text-white">{{ message.text }}</div>
      <div class="alert-close">
        <button type="button" class="close text-white" @click="closeAlert">
          <span aria-hidden="true"><BaseIcon type="fas" icon="times" size="sm" /></span>
        </button>
      </div>
    </div>

    <form class="kt-form" @submit="sendResetPassword" v-if="!isCompleted">
      <div class="form-group">
        <input
          type="password"
          class="form-control"
          placeholder="New password"
          autocomplete="off"
          :disabled="isLoading || isCompleted"
          :required="true"
          v-model="new_password">
      </div>
      <div class="form-group">
        <input
          type="password"
          class="form-control"
          placeholder="Confirm password"
          autocomplete="off"
          :disabled="isLoading || isCompleted"
          :required="true"
          v-model="new_password_again">
      </div>
      <div class="kt-login__actions">
        <button
          type="submit"
          class="btn btn-primary btn-wide"
          :disabled="isLoading || isCompleted">Change my password</button>
      </div>
    </form>
  </FormWrapper>
</template>

<script>
import FormWrapper from '@/components/login/FormWrapper.vue'
import NProgress from 'nprogress'

export default {
  name: 'FormPasswordReset',
  components: {
    FormWrapper
  },
  data () {
    return {
      isLoading: false,
      message: { text: '', class: '' },
      new_password: '',
      new_password_again: '',
      isCompleted: false
    }
  },
  computed: {
    messageObj () {
      return {
        'show': this.message.text,
        'alert-danger': this.message.class === 'error',
        'alert-warning': this.message.class === 'warning',
        'alert-success': this.message.class === 'success'
      }
    }
  },
  methods: {
    sendResetPassword (e) {
      e.preventDefault()
      NProgress.start()
      this.isLoading = true
      const token = this.$route.query.token
      // eslint-disable-next-line
      const new_password = this.new_password
      // eslint-disable-next-line
      const new_password_again = this.new_password_again
      // Confirm reset password ========================================
      this.$store
        .dispatch('auth/recoveryPassword')
        .then(response => {
          const hash = response.data.hash
          const payload = { token, hash, new_password, new_password_again }
          this.$store
            .dispatch('auth/confirmResetPassword', payload)
            .then(response => {
              const text = response.data.message
              const status = response.data.status
              if (status) {
                this.isCompleted = true
                this.new_password = ''
                this.new_password_again = ''
                this.message = { text, class: 'success' }
              } else {
                this.message = { text, class: 'warning' }
              }
              this.isLoading = false
              NProgress.done()
            })
            .catch((error) => {
              const text = error.response.data.message
              this.isLoading = false
              this.isCompleted = false
              this.message = { text, class: 'error' }
              NProgress.done()
              console.log(error)
            })
        })
        .catch((error) => {
          const text = error.response.data.message
          this.isLoading = false
          this.isCompleted = false
          this.message = { text, class: 'error' }
          NProgress.done()
          console.log(error)
        })
    },
    redirect (name) {
      this.$router.replace({ name })
    },
    closeAlert () {
      this.message = ''
    }
  }
}
</script>
